/**
 * Unabhängige Internet-Recherche (ARKORBIT-Gate).
 * Nicht LEXCORE, nicht OGH-Snapshot, keine Akte im Query.
 */

export const WEB_SEARCH_INTENT = 'web_recherche' as const;
export const WEB_SEARCH_CHIP_ACTION = 'web_recherche' as const;
export const WEB_SEARCH_FOLLOWUP_LABEL = 'Im Internet recherchieren';

export function buildWebSearchLookupPrompt(query: string): string | null {
  const q = query.replace(/\s+/g, ' ').trim();
  if (!q) return null;
  return q.slice(0, 240);
}

export function webSearchLookupRequest(query: string): {
  intent: typeof WEB_SEARCH_INTENT;
  webSearchMode: true;
  chip_action: typeof WEB_SEARCH_CHIP_ACTION;
  chatInput: string;
} | null {
  const chatInput = buildWebSearchLookupPrompt(query);
  if (!chatInput) return null;
  return {
    intent: WEB_SEARCH_INTENT,
    webSearchMode: true,
    chip_action: WEB_SEARCH_CHIP_ACTION,
    chatInput,
  };
}
